import React from "react";
import "./locationList.css";

import Logo from "../../../images/RED-FOX-LOGO.png";

import pinImage from "../../../images/icons/location-pin.png";

export default function LocationList({ data, onSelect }) {
  const locations = data.DeliverLocations.map((val) => {
    return (
      <div
        className="location-item"
        key={val.DeliverLocationId}
        onClick={(e) => onSelect(e, val.DeliverLocationId)}
      >
        <img src={pinImage} alt="" className="location-item-image" />
        <span className="location-item-name">{val.LocationTitle}</span>
      </div>
    );
  });

  return (
    <div className="location-main-part">
      <div className="location-header">
        <div className="header-icon">
          <img src={Logo} alt="logo" />
        </div>
        <div className="header-text">
          <span className="cafe-name">RED FOX</span>
          <span className="cafe-name-desc">Coffee Shop</span>
          <span className="header-main-text">من نمیام تو بیا</span>
        </div>
      </div>

      <div className="location-text-box">
        <div className="white-main-text-box">
          با انتخاب یکی از لوکیشن ها جایی که هستی به ما بگو
          <span className="red-bold-text">ما واست سفارشت میاریم</span>
        </div>
        <div className="red-small-text-box">کجایی ؟</div>
      </div>

      <div className="location-list custom-scroll">{locations}</div>
    </div>
  );
}
